import { useListStrategiesQuery } from "features/trading/accounts";
import { getLastStatisticStrategyId } from "helpers";

export const useStrategyQuery = () => {
  const lastStrategyId = getLastStatisticStrategyId();

  return useListStrategiesQuery({
    pagination: { page: 0, pageSize: 1 },
    filters: {
      id: lastStrategyId || undefined
    }
  }, {
    selectFromResult: ({ data, ...rest }) => ({
      data: data?.results?.[0] || null,
      ...rest
    }),
  });
};
